import styled from "styled-components"
import * as PropTypes from "prop-types"
import Typography from "components/styled/Typography"
import { useT } from "react-polyglot-hooks"
import { mq } from "helpers/styled"

const Wrapper = styled.div`
  flex: 0 0 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${mq("lg")} {
    flex-basis: ${100 / 3}%;
  }

  @media ${mq("xl")} {
    flex-basis: ${100 / 4}%;
  }
`

const Container = styled.div`
  height: 100%;
  max-width: 375px;
  padding: 0 25px;
  text-align: center;
`

const ImageWrapper = styled.div`
  position: relative;
  margin: auto;
  width: 100%;
  max-width: 270px;
  height: 220px;
  border-radius: 8px;
  overflow: hidden;
`

const Img = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
`

const Content = styled.div`
  padding: 1rem 0;
  text-align: center;
`

export default function Testimonial({ testimonial: { name, content, image, car } }) {
  const t = useT()

  return (
    <Wrapper>
      <Container>
        <ImageWrapper>
          <Img
            width="270"
            height="220"
            src={`${process.env.NEXT_PUBLIC_CLOUDINARY}h_220,w_270,q_auto,c_fill/micochederenting/testimonials/${image}`}
            alt={t("landings.testimonials.image_alt", { car })}
            loading="lazy"
          />
        </ImageWrapper>
        <Content>
          <Typography weight="medium">{name}</Typography>
          <Typography variant="small" weight="light">
            {car}
          </Typography>
        </Content>
        <Typography variant="small" weight="light" color="skyBlue" center>
          {content}
        </Typography>
      </Container>
    </Wrapper>
  )
}

Testimonial.propTypes = {
  testimonial: PropTypes.object.isRequired
}
